module.exports = __webpack_public_path__ + "img/logo.ef98e463.png";